import { Siniestro, SiniestroReq } from '../../types/Siniestro/types';
import { apiRequest } from '../Utils/apiClient';
import { GET_SINIESTROS, SINIESTROS } from '../Utils/constants';

const postSiniestro = (siniestro: SiniestroReq) =>
  apiRequest<SiniestroReq>('post', SINIESTROS, siniestro).then((res) => ({
    ok: res.success,
    data: res.data,
    error: res.error,
  }));

const getSiniestros = (petId: string) =>
  apiRequest<Siniestro[]>('get', GET_SINIESTROS, { id: petId });

export { postSiniestro, getSiniestros };
